<template>
  <AdminModal
    :confirm-button-title="`확인`"
    :modal-title="modalTitle"
    :is-open="isModalOpen" 
    :confirm="handleConfirm"
    :close="handleCancel"
    name="commonModal"
  >
    <div class="py-2 px-2">
      <div v-html="modalHTML"/>
    </div>
  </AdminModal>
</template>

<script>
import AdminModal from "@/components/modals/AdminModal.vue";
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {AdminModal},
  name: 'CommonModal',
  computed: {
    ...mapGetters('modal', [
      'isModalOpen',
      'modalType',
      'modalHTML',
      'modalTitle'
    ])
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    handleConfirm() {
      // 스토어에서 confirm 함수 실행
      this.$store.state.modal.confirm();
      this.closeModal();
    },
    handleCancel() {
      // 스토어에서 cancel 함수 실행
      this.closeModal();
    }
  }
}
</script>

<style scoped>

</style>